import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Logo = ({ className = '', size = 'medium' }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const sizes = {
    small: 'h-8',
    medium: 'h-12',
    large: 'h-20',
  };

  const handleClick = () => {
    // On home page, navigate to login
    if (location.pathname === '/') {
      navigate('/login');
    } else {
      // On all other pages, navigate to home
      navigate('/');
    }
  };

  return (
    <div 
      onClick={handleClick}
      className={`cursor-pointer hover:opacity-80 transition ${className}`}
    >
      <img 
        src="https://customer-assets.emergentagent.com/job_vet-staffing/artifacts/aaq8vnrr_remove.photos-removed-background%20%282%29.png"
        alt="LIBERADO"
        className={`${sizes[size]} object-contain`}
        style={{
          imageRendering: 'crisp-edges',
          WebkitFontSmoothing: 'antialiased',
        }}
      />
    </div>
  );
};

export default Logo;